import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { SysAdminStore } from '../store/SysAdmin';
import { Method, SysAdminAPIDto } from '../types';
import {
  Button,
  TextInput,
  Layout
} from '@iba-team/portal-react-components/dist';
import Api from '../api/API';

const SysAdminPage = observer(() => {
  const [urls, setUrls] = useState<Record<string, string>>({}); // Stores URLs for each API

  useEffect(() => {
    // Fetching the APIs first and then setting the URLs
    const fetchData = async () => {
      await SysAdminStore.getSysAdminAPIs(); // Fetch API data
      const initialUrls = SysAdminStore.allRequests.reduce((acc, api) => {
        // Initialize each API URL based on the api data
        acc[api.api] = `${process.env.REACT_APP_LM_NO_PORT_URL}:${api.port}${api.api}`;
        return acc;
      }, {} as Record<string, string>);

      setUrls(initialUrls); // Update state with initial URLs
    };

    fetchData();
  }, []);

  const handleSubmit = async (api: SysAdminAPIDto) => {

    const urlToUse = urls[api.api]; // Use the URL from state, or fallback

    const method: Method = api.method.toUpperCase() as Method;
    sendAdminRequest(method, urlToUse);

  };


  async function sendAdminRequest(methodName: Method, url: string) {

    switch (methodName) {
    case 'GET':
      return Api<null, null>().get(url);
    case 'POST':
      return Api<null, null>().post(url, null);
    case 'PUT':
      return Api<null, null>().put(url);
    case 'DELETE':
      return Api<null, null>().delete(url);
    }
  }


  const handleUrlChange = (api: SysAdminAPIDto, event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedUrls = { ...urls, [api.api]: event.target.value }; // Update the URL for the corresponding API
    setUrls(updatedUrls);
  };

  return (
    <Layout>
      <h1>Available APIs</h1>
      <ul>
        {SysAdminStore.allRequests.map((api, index) => (
          <li key={index}>
            <h3>{api.title}</h3>
            <p>{api.description}</p>
            <p>
              <strong>Method:</strong> {api.method}
            </p>
            <div>
              <strong>API URL:</strong>{' '}
              {/* Editable input field for URL for each API */}
              <TextInput
                type='text'
                value={urls[api.api] || `${process.env.REACT_APP_LM_NO_PORT_URL}:${api.port}${api.api}`}
                onChange={(e) => handleUrlChange(api, e)} // Update the URL for the specific API
                placeholder='Edit API URL'

              />
            </div>
            {api.parametersDescription && (
              <p>
                <strong>Parameters:</strong><br></br>
                <span
                  dangerouslySetInnerHTML={{
                    __html: api.parametersDescription,
                  }}
                />
              </p>
            )}
            {/* Button with click handler for each API */}
            <Button theme={{ variant: 'primary', color: 'theme' }} style={{ marginTop: '4px' }} onClick={() => handleSubmit(api)} >
              Submit
            </Button>
            {index !== SysAdminStore.allRequests.length - 1 && <hr />}
          </li>
        ))}
      </ul>
    </Layout>
  );
});

export default SysAdminPage;